<div hide-in-percy>
	<div #channelTarget></div>
</div>
